const config = {
  env: 'admin',
  initPlugins: [
    'init',
    'admin',
    'vuexStorage',
    'userInit'
  ],
  title: '磁博士管理后台'
}
export default config



// WEBPACK FOOTER //
// ./src/configs/admin.js